<ng-template #setupModal let-modal>
	<div class="modal-header">
		<h4 *ngIf="selectedLoc" class="modal-title" id="modal-title">Editing {{ selectedLoc.name }}</h4>
		<h4 *ngIf="!selectedLoc" class="modal-title" id="modal-title">New Loyalty Program</h4>
		<button type="button" mat-flat-button color="accent" (click)="saveReward()"><mat-icon>save</mat-icon> Save Changes </button>&nbsp;
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">		
			<form [formGroup]="locForm">		
			<div class="container-fluid">
			<div class="row eduform">
			<div class="col-12">
			<mat-form-field appearance="outline">
			<mat-label>Loyalty Program Name</mat-label>
			<input matInput formControlName="name" class="margin-top" autocomplete="off">			
			</mat-form-field>
			</div>
			</div>
			
			<div class="col-12">
			<mat-form-field appearance="outline">
			<mat-label>Type</mat-label>
			<mat-select matInput formControlName="type" class="margin-top">
			<mat-option value="1"> Dollar Amount </mat-option>
			<mat-option value="2"> Dollar Amount w/ Required Text </mat-option>
			</mat-select>
			</mat-form-field>
			</div>
			<div class="col-12">
			<mat-form-field appearance="outline">
			<mat-label>Required Text</mat-label>
			<input matInput formControlName="text" class="margin-top" autocomplete="off">
			</mat-form-field>
			</div>
			<div class="col-12">
			
			<mat-label>Enabled?</mat-label>
			<mat-slide-toggle formControlName="enabled"></mat-slide-toggle>
			
			</div>
			</div>
			</form>
	</div>
</ng-template>
<div class="main-content">
<div class="container-fluid">
	<div class="row">
		<div class="col-md-12">
			<div class="card">
				<div class="card-header card-header-{{color}}-6">
					<h4 class="card-title "><i class="material-icons" (click)="back()">arrow_left</i> Education Loyalty Programs</h4>
					<p class="card-category text-right"></p>
				</div>
				<div class="card-body">
				<button mat-stroked-button (click)="addReward()" >
												<mat-icon>add</mat-icon>
												<span>Add</span>
											</button>
				<div class="table-wrapper"  *ngIf="!loading && loclist.length">
									<mat-paginator [pageSizeOptions]="items_per_page" [pageSize]="pagesizedefault"></mat-paginator>
									  <table class="table table-sm table-striped">
										<thead class="thead-dark">
										  <tr>
											<th></th>
											<th >Program Name</th>
											<th >Type</th>
											<th class="text-center">Text</th>
											<th class="text-center">Status</th>
										  </tr>
										</thead>
										<tbody>
										<tr class="datarow" *ngFor="let r of dataObs | async;let i = index">
											<td><button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Actions">
											<mat-icon>more_vert</mat-icon>
											</button><mat-menu #menu="matMenu">
											
											<button mat-menu-item (click)="editReward(r)" >
												<mat-icon>edit</mat-icon>
												<span>Edit Program</span>
											</button>
											<button mat-menu-item (click)="deleteReward(r)">
												<mat-icon>remove</mat-icon>
												<span>Remove Program</span>
											</button>
										</mat-menu></td>
											<td class="text-center ">
												{{ r.name }}.
											</td>
											<td>{{ r.type == '2' ? 'Dollar amt w/ Additional Text' : 'Dollar amt' }}</td>
											<td>{{ r.text }}</td>
											<td>{{ r.enabled ? 'Enabled' : 'Disabled' }}</td>
											
											</tr>
										</tbody>
									  </table>
									</div>
									<div class="table" *ngIf="!loading && !loclist.length">
										<h4 class="text-center"> No Results</h4>
									</div>
				</div>
			</div>
		</div>
	</div>
</div>